// src/components/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import Loader from "../OtherComponents/Loader";
import { login, setAuthToken } from "../../utils/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { email, password } = formData;
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const validate = () => {
    const errors = {};
    if (!email) errors.email = "Email is required";
    if (!password) errors.password = "Password is required";
    else if (password.length < 6)
      errors.password = "Password must be at least 6 characters";
    return errors;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      try {
        setLoading(true);
        const res = await login(formData);
        setAuthToken(res.data.token);
        toast.success("Login Successful!");
        setTimeout(() => {
          setLoading(false);
        }, 1000);

        setTimeout(() => {
          setFormData({ email: "", password: "" });
        }, 1000);

        setTimeout(() => {
          localStorage.setItem("role", res.data.user.role);
          if (res.data.user.role === "admin") {
            navigate("/", {
              state: { navigate: true, role: res.data.user.role },
            });
          } else {
            navigate("/", { state: { navigate: true } });
          }
        }, 1000);
      } catch (err) {
        console.error(err.response.data);
        setTimeout(() => {
          setErrors({ server: err.response.data.msg });
          toast.error(err.response.data.msg);
          setLoading(false);
        }, 1000);
      }
    }
  };

  return (
    <>
      <Header />
      <ToastContainer />
      <div className="topHeading">
        <h2>Login</h2>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="form-content">
          <form onSubmit={onSubmit} className="my-form login_form">
            <input
              type="email"
              name="email"
              value={email}
              onChange={onChange}
              placeholder="Email"
              required
            />
            {errors.email && <p className="error">{errors.email}</p>}
            <div className="password-container2">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={password}
                onChange={onChange}
                placeholder="Password"
                required
              />
              <FontAwesomeIcon
                icon={showPassword ? faEyeSlash : faEye}
                onClick={() => setShowPassword(!showPassword)}
                className="password-toggle-icon"
              />
            </div>
            <div className="under-password-div">
              {errors.password ? (
                <p className="error">{errors.password}</p>
              ) : (
                <p className="None"></p>
              )}
              <a
                className="forgotPassword"
                href={`/forgotPassword`}
                onClick={() => {
                  setFormData({});
                }}
              >
                Forgot Password
              </a>
            </div>
            <button type="submit">{!loading && "Login"}</button>
            {errors.server && <p className="error">{errors.server}</p>}
            <p>
              Create an account{" "}
              <a
                href="/register"
                onClick={() => {
                  setFormData({});
                }}
              >
                Register
              </a>{" "}
            </p>
          </form>
        </div>
      )}
      <Footer />
    </>
  );
};

export default Login;
